import { Form, Formik } from "formik";
import { FormSelect } from "../../components/Form/FormInput/FormSelect";
import { IPContainer } from "./Components"
import { useTranslation } from "react-i18next";
import { useModal } from "../../hooks/useModal";
export const IPBlockConfirm = ({durationRef, text, duration = true}) => {
    const {t} = useTranslation();
    return (
        <IPContainer>
            <span>{text}</span>
            {duration && <Formik
                initialValues={{
                    duration: durationRef.current
                }}
            >
                {(formik) => (
                    <Form>
                        <FormSelect theme={"light"} name={"duration"} formik={formik} onChange={(e) => {
                                formik.handleChange(e);   
                                durationRef.current = (e.target.value)
                            }}>
                            <option value={86400} >{t("a day")}</option>
                            <option value={86400 * 7} >{t("a week")}</option>
                            <option value={86400 * 30} >{t("a month")}</option>
                            <option value={86400 * 365} >{t("a year")}</option>
                        </FormSelect>
                    </Form>
                )}
            </Formik>}
            
        </IPContainer>
    )
}